//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapGetters } from "vuex";
import CustomStarRate from "~/components/common/CustomStarRate.vue";
import RateOrderMixin from "~/mixins/rate/RateOrderMixin";

export default {
    name: "HistoryRatePopup",
    components: { CustomStarRate },
    mixins: [RateOrderMixin],
    data() {
        return {
            rating: 0,
        };
    },
    computed: {
        ...mapGetters("rateProducts", ["getPopupOrder"]),
        order() {
            return this.getPopupOrder;
        },
        title() {
            return this.order.can_score && this.isLessThan3Days
                ? "Оцените прошлый заказ"
                : "Оцените блюда из прошлого заказа";
        },
        products() {
            return this.order.products;
        },
        isMuchProducts() {
            return this.products.length > 4;
        },
        countOtherProducts() {
            return this.products.length - 3;
        },
        getFirstThreePhotos() {
            return this.isMuchProducts ? this.products.slice(0, 3) : this.products.slice(0, 4);
        },
    },
    methods: {
        ...mapActions("modals", ["openModal"]),
        ...mapActions("rateProducts", ["rateOrder"]),
        openModalRate() {
            this.openModal({
                modalName: "RateProductsPopup",
                componentProps: {
                    size: "m",
                    overflowHidden: true,
                },
            });
        },
    },
    watch: {
        rating(nv) {
            this.rateOrder({ order_id: this.order.id, score: nv });
            this.$emit("close");
            this.openModalRate();
        },
    },
};
